import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const SectionHeader = ({ headerText, type, icon, text }) => {
  return (
    <div className="caseListSectionHeaderContainer">
      {type === "logoText" ? (
        <p className="castListSectionLogoText">{headerText}</p>
      ) : (
        <FontAwesomeIcon icon={icon} className="caseListSectionIcon" />
      )}
      <h1 className="caseListSectionHeader">{text}</h1>
    </div>
  );
};

export default SectionHeader;
